/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { isMobile } from '../../utils'
import  {  MapMini, Menu } from '../../components'

const Map = ({ className = "", currentSite }) => { 

  const [ open, setOpen ] = useState(true);

  return (
    <div className={`background-dark p-0 relative vh-100 z-index-20 ${className}`} style={{width: '100%', maxWidth: '1920px', background: 'url(https://media-cdn.tripadvisor.com/media/vr-splice-j/0a/49/64/56.jpg) no-repeat', backgroundSize:"cover"}}>
      <div className="container-fluid h-100">
        <div className="row h-100">
          <Menu setOpen={setOpen} open={open}/>
          {!isMobile() &&
          <div className="col-12 p-0">
            <MapMini currentSite={currentSite} />
          </div>
          }
        </div>
      </div>
    </div>
  )
}

export default React.memo(Map)
